import { MAX_FEEDBACK_LENGTH, SCORE_HIGH, SCORE_LOW } from './types'

export function validateScore(x: unknown) {
    return typeof x === 'number' && x >= SCORE_LOW && x <= SCORE_HIGH
}

export function validateFeedback(x: unknown) {
    return typeof x === 'string' && x.length <= MAX_FEEDBACK_LENGTH
}

export function validateTopN(x: unknown, n: number) {
    return Array.isArray(x) && x.length > 0 && x.length <= n && typeof x[0] === 'string'
}

export function validateSelection(x: unknown) {
    return typeof x === 'string' && x.length > 0
}
